import { render, staticRenderFns } from "./RoundCrest.vue?vue&type=template&id=5186b8af&scoped=true"
import script from "./RoundCrest.vue?vue&type=script&lang=js"
export * from "./RoundCrest.vue?vue&type=script&lang=js"
import style0 from "./RoundCrest.vue?vue&type=style&index=0&id=5186b8af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186b8af",
  null
  
)

export default component.exports